import { DisplayController } from './display.controller';

const dcHtml = require('./display.html');

/* @ngInject */
export function displayDirective(RecursionHelper): ng.IDirective {
  return {
    scope: {
      conditionGroup: '=',
      condition: '=',
      models: '=',
      isEditing: '=',
      isChildEditing: '=',
      isRoot: '=',
      isLast: '=',
      detailsVisible: '=?'
    },
    restrict: 'E',
    replace: true,
    templateUrl: dcHtml,
    controller: DisplayController,
    controllerAs: 'fdDisplayConditionCtrl',
    compile: (element) => RecursionHelper.compile(element, () => void 0)
  };
}
